import {toAbsoluteUrl} from '_metronic/helpers'
import {FC, useState, useEffect} from 'react'
import Searchbar from '../components/Searchbar'
import {SubprocessorDataType} from '../components/Subprocessors'
import {Accordion, OverlayTrigger, Tooltip} from 'react-bootstrap'
import FAQ, {FAQDataType} from '../components/FAQ'

type Props = {
  FAQs: FAQDataType[]
}

const FAQTab: FC<Props> = ({FAQs}) => {
  const [filteredFAQs, setFilteredFAQs] = useState<FAQDataType[]>(FAQs)
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [isNoSearchFound, setIsNoSearchFound] = useState(false)
  const [activeKeys, setActiveKeys] = useState<Array<string>>([])
  const [allKeys, setAllKeys] = useState<Array<string>>([])

  const handleToggleAll = () => {
    if (activeKeys.length === allKeys.length) {
      setActiveKeys([]) // Collapse all
    } else {
      setActiveKeys(allKeys) // Expand all
    }
  }

  const handleToggleItem = (key: string) => {
    setActiveKeys((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]))
  }

  useEffect(() => {
    setFilteredFAQs(FAQs)
    setAllKeys(Array.from({length: FAQs.length}, (_, i) => `${i}`))
  }, [FAQs])

  useEffect(() => {
    const updatedData = FAQs.filter((faq) =>
      faq.question.toLocaleLowerCase().includes(searchTerm.toLowerCase())
    )

    setFilteredFAQs(updatedData)
    setAllKeys(Array.from({length: updatedData.length}, (_, i) => `${i}`))
    setIsNoSearchFound(updatedData.length === 0)
  }, [searchTerm])

  return (
    <div className='w-100 d-flex flex-column flex-lg-row' style={{gap: '32px'}}>
      <div className='w-100 w-lg-25 d-flex flex-column' style={{gap: '12px', flexShrink: '0'}}>
        <div className='d-flex justify-content-between align-items-center'>
          <h3
            className='d-lg-none flex-fill text-custom-primary-gray mb-0'
            style={{fontSize: '20px', fontWeight: '600'}}
          >
            FAQ
          </h3>

          <div className='flex-lg-fill'>
            <Searchbar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </div>
        </div>
      </div>

      <div className='flex-fill d-flex flex-column' style={{gap: '20px'}}>
        {!isNoSearchFound ? (
          filteredFAQs.length > 0 && (
            <Accordion className='neutral-accordion' activeKey={activeKeys} alwaysOpen>
              {filteredFAQs.map((faq, index) => (
                <div
                  key={faq.id}
                  style={{
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    marginBottom: '24px',
                    padding: '0.5px',
                  }}
                >
                  <Accordion.Item
                    eventKey={`${index}`}
                    style={{
                      border: 'none',
                    }}
                  >
                    <Accordion.Header onClick={() => handleToggleItem(`${index}`)}>
                      <span className='text-custom-primary-gray fw-medium' style={{fontSize: '16px'}}>
                        {faq.question}
                      </span>
                    </Accordion.Header>

                    <Accordion.Body className='text-custom-secondary-gray' style={{fontSize: '14px'}}>
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
              ))}
            </Accordion>
          )
        ) : (
          <div
            className='w-100 h-100 d-flex align-items-center justify-content-center'
            style={{border: '1px solid #D1D5DB', borderRadius: '8px', paddingBlock: '24px'}}
          >
            <span className='text-custom-primary-gray fw-medium' style={{fontSize: '16px'}}>
              {FAQs.length === 0 ? 'No FAQ added' : 'No matching FAQ found'}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default FAQTab
